import {useMutation} from 'react-query';
import {campaignService} from 'src/shared/services/campaigns';
import {ICampaignPayload} from 'src/shared/services/campaigns/dto/campaign-list';

export const useSendMassEmail = () => {
  return useMutation((payload: ICampaignPayload) => {
    return campaignService.sendMassEmail(payload);
  });
};
